import {createFeatureSelector, createSelector} from "@ngrx/store";
import {DbStoreState} from "../reducers";
import {IEcommercePerformanceNowEntityState} from "../reducers/ecommerce-performance-now.reducer";

const getDbStoreState = createFeatureSelector<DbStoreState>('dbStore');

export const getEcommercePerformanceNowState = (websiteId: number) =>
  createSelector(getDbStoreState, (dbStoreState: DbStoreState) => dbStoreState.ecommercePerformanceNow.entities[websiteId]);

export const getEcommercePerformanceTotalNow = (websiteId: number) => createSelector(getEcommercePerformanceNowState(websiteId),
  (state: IEcommercePerformanceNowEntityState) => {
      if (!state?.dataForToday) return {};
      return {
          totalSales: state.dataForToday.find(value => value?.stat === "revenue/total_sales"),
          netRevenue: state.dataForToday.find(value => value?.stat === "revenue/net_revenue"),
          ordersCount: state.dataForToday.find(value => value?.stat === "orders/orders_count"),
          itemsSold: state.dataForToday.find(value => value?.stat === "products/items_sold"),
          totalTax: state.dataForToday.find(value => value?.stat === "taxes/total_tax"),
          itemsSoldNumber: state.dataForToday.find(value => value?.stat === "variations/items_sold")
      };
  }
);

export const getEcommercePerformanceNowLoading = (websiteId: number) => createSelector(getEcommercePerformanceNowState(websiteId),
  (state: IEcommercePerformanceNowEntityState) => state && state.loading
);

export const getEcommercePerformanceNowLoaded = (websiteId: number) => createSelector(getEcommercePerformanceNowState(websiteId),
  (state: IEcommercePerformanceNowEntityState) => state && state.loaded
);
